import React from 'react';
import {Route, Switch} from "react-router";
import ListPage from "./ListPage";
import ViewPage from "./ViewPage";

class ProcessPage extends React.Component {

    render() {

        return (
            <Switch>
                <Route exact path="/process"                component={ListPage}/>
                <Route       path="/process/:view/:id"            component={ViewPage}/>
                <Route       path="/process/:edit/:id"            component={ViewPage}/>
            </Switch>
        );
    }
}

export default ProcessPage;